const Config = {
    backendUrl: 'https://checkout-stg.eshopmgt.com',
    originKey: 'pub.v2.8015905840681305.aHR0cDovL2xvY2FsaG9zdDozMDAw.9fbb4NFPdiCCCuNAEk-gxIcyRE8WsJIWvC4_veWTnng'
};
export default Config;
